





























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { InputResponse } from '@/constants/form/types'

@Component({})
export default class InputNoVModel extends Vue {
  // 要素タイプ
  @Prop({ default: 'text' })
  private type?: string;
  // 入力要素名
  @Prop({ default: '' })
  private name!: string;
  // 入力要素ラベルテキスト
  @Prop({ default: '項目' })
  private labelText?: string;
  // 入力要素初期値
  @Prop({ default: '' })
  private value?: string;
  // 入力要素プレースホルダ
  @Prop({ default: '' })
  private placeholder?: string;
  // 入力要素最大入力数
  @Prop({ default: '' })
  private maxlength?: string;
  // 入力要素がアクティブか否か
  @Prop({ default: false })
  private isDisabled?: boolean;
  // 読み取り専用
  @Prop({ default: false })
  private isReadOnly?: boolean;
  // アイコンの付与
  @Prop({ default: '' })
  private appendIcon?: string;

  @Prop({ default: '' })
  private prependIcon?: string;
  // アイコンを入力エリア内に付与する
  @Prop({ default: '' })
  private prependInnerIcon?: string;
  // rulesの付与
  @Prop({ default: '' })
  private rules?: string;
  
  public inputVal = '';
  public errMessage = '';

  mounted() {
    if (this.value) {
      this.inputVal = this.value;
    }
  }

  private get inputValue(): string {
    return this.inputVal;
  }

  private set inputValue(inputVal: string) {
    this.inputVal = inputVal;
  }

  /**
   * 親コンポーネントに入力値を通知する
   * @module inputOperation
   * @return InputResponse - 名前と入力値
   */
  @Emit('inputOperation')
  public inputOperation(data:string): InputResponse {
    return { name: this.name, value: data };
  }
}
